var _path, _mask, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 0C11.4624 0 9 2.46243 9 5.5C9 8.53757 11.4624 11 14.5 11H16V12.5858C16 13.4767 17.0771 13.9229 17.7071 13.2929L20 11H20.5C23.5376 11 26 8.53757 26 5.5C26 2.46243 23.5376 0 20.5 0H14.5Z",
    fill: "#474C55"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2499_3572",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 7C14.5376 7 17 9.46243 17 12.5C17 15.5376 14.5376 18 11.5 18H10V19.5858C10 20.4767 8.92286 20.9229 8.29289 20.2929L6 18H5.5C2.46243 18 0 15.5376 0 12.5C0 9.46243 2.46243 7 5.5 7H11.5Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 7C14.5376 7 17 9.46243 17 12.5C17 15.5376 14.5376 18 11.5 18H10V19.5858C10 20.4767 8.92286 20.9229 8.29289 20.2929L6 18H5.5C2.46243 18 0 15.5376 0 12.5C0 9.46243 2.46243 7 5.5 7H11.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H8.5V16.5H10V18ZM6 18V16.5H6.62132L7.06066 16.9393L6 18ZM15.5 12.5C15.5 10.2909 13.7091 8.5 11.5 8.5V5.5C15.366 5.5 18.5 8.63401 18.5 12.5H15.5ZM11.5 16.5C13.7091 16.5 15.5 14.7091 15.5 12.5H18.5C18.5 16.366 15.366 19.5 11.5 19.5V16.5ZM10 16.5H11.5V19.5H10V16.5ZM8.5 19.5858V18H11.5V19.5858H8.5ZM9.35355 19.2322C9.03857 18.9173 8.5 19.1403 8.5 19.5858H11.5C11.5 21.8131 8.80714 22.9285 7.23223 21.3536L9.35355 19.2322ZM7.06066 16.9393L9.35355 19.2322L7.23223 21.3536L4.93934 19.0607L7.06066 16.9393ZM5.5 16.5H6V19.5H5.5V16.5ZM1.5 12.5C1.5 14.7091 3.29086 16.5 5.5 16.5V19.5C1.63401 19.5 -1.5 16.366 -1.5 12.5H1.5ZM5.5 8.5C3.29086 8.5 1.5 10.2909 1.5 12.5H-1.5C-1.5 8.63401 1.63401 5.5 5.5 5.5V8.5ZM11.5 8.5H5.5V5.5H11.5V8.5Z",
    fill: "#474C55",
    mask: "url(#path-2-inside-1_2499_3572)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H12",
    stroke: "#474C55",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChat);
export default __webpack_public_path__ + "static/media/icon_chat.d64272e52cdd6901fb81697665e6ea97.svg";
export { ForwardRef as ReactComponent };